// src/storage.js
/**
 * Storage Initialization
 * This file sets up the storage system for the app
 * Now using Firebase Firestore instead of localStorage
 */

import firebaseStorage from './services/firebaseStorage';

// Initialize Firebase storage on window object for backward compatibility
window.storage = firebaseStorage;

// Also export for direct imports
export default firebaseStorage;
export { firebaseStorage as storage };

/**
 * Collection Structure in Firestore:
 * 
 * - clubs/{clubId}
 * - teams/{teamId}
 * - tournaments/{tournamentId}
 * - games/{gameId}
 * - expenses/{expenseId}
 * - players/{playerId}
 * - club-games/{clubId} - stores array of game IDs
 * - club-expenses/{clubId} - stores array of expense IDs
 * 
 * Example Usage:
 * await window.storage.get('club:abc123')
 * await window.storage.set('team:xyz789', JSON.stringify(teamData))
 * await window.storage.delete('expense:exp001')
 */

console.log('Firebase storage initialized successfully');